import React, { useState } from 'react';
import { Check, X } from 'lucide-react';
import { Select } from './Select';
import { Input } from './Input';
import { Button } from './Button';
interface CreatableSelectProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  options: string[];
  onCreate: (value: string) => string;
  placeholder?: string;
  newPlaceholder?: string;
  newOptionLabel?: string;
  required?: boolean;
  error?: string;
}
const NEW_OPTION = '__new__';
export function CreatableSelect({
  label,
  value,
  onChange,
  options,
  onCreate,
  placeholder = 'Seleziona...',
  newPlaceholder = 'Inserisci nuovo tipo',
  newOptionLabel = '+ Aggiungi nuovo tipo...',
  required,
  error
}: CreatableSelectProps) {
  const [isAdding, setIsAdding] = useState(false);
  const [draft, setDraft] = useState('');

  // Keep a stored value visible even if it is not in the list yet
  const allOptions = value && !options.includes(value) ? [...options, value] : options;
  const confirm = () => {
    if (draft.trim()) {
      onChange(onCreate(draft));
    }
    setDraft('');
    setIsAdding(false);
  };
  const cancel = () => {
    setDraft('');
    setIsAdding(false);
  };
  return <div data-id="element-1700" data-mp="27zz8ytmgccpr">
      <Select label={label} required={required} value={isAdding ? NEW_OPTION : value} onChange={e => {
      if (e.target.value === NEW_OPTION) {
        setIsAdding(true);
      } else {
        setIsAdding(false);
        onChange(e.target.value);
      }
    }} options={[{
      value: '',
      label: placeholder
    }, ...allOptions.map(o => ({
      value: o,
      label: o
    })), {
      value: NEW_OPTION,
      label: newOptionLabel
    }]} error={error} data-id="element-1701" data-mp="28092usamb40q" />
      {isAdding && <div className="mt-2 flex gap-2 items-center" data-id="element-1702" data-mp="1u1rgoz0d1zkx">
          <div className="flex-1" data-id="element-1703" data-mp="3jg633cnwpad9">
            <Input autoFocus aria-label={`Nuovo valore per ${label}`} placeholder={newPlaceholder} value={draft} onChange={e => setDraft(e.target.value)} onKeyDown={e => {
          if (e.key === 'Enter') {
            e.preventDefault();
            confirm();
          }
          if (e.key === 'Escape') cancel();
        }} data-id="element-1704" data-mp="3jcs2a8uw597x" />
          </div>
          <Button type="button" size="sm" variant="flat" color="success" className="!px-2" onClick={confirm} disabled={!draft.trim()} aria-label="Aggiungi" data-id="element-1705" data-mp="38ylsm5hh4idd">
            <Check className="h-4 w-4" data-id="element-1706" data-mp="3vwowg6118sir" />
          </Button>
          <Button type="button" size="sm" variant="flat" color="danger" className="!px-2" onClick={cancel} aria-label="Annulla" data-id="element-1707" data-mp="3vv44mo63rnol">
            <X className="h-4 w-4" data-id="element-1708" data-mp="nh58nmj4s2b3" />
          </Button>
        </div>}
    </div>;
}